export default "__VITE_ASSET___081TUF4__"